import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface OnboardingCardProps {
  message: string;
  onDismiss: () => void;
  dismissing: boolean;
}

export const OnboardingCard: React.FC<OnboardingCardProps> = ({
  message,
  onDismiss,
  dismissing,
}) => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg px-6 py-4">
      <div className="prose max-w-none prose-sm text-slate-700">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{message}</ReactMarkdown>
      </div>
      <div className="mt-4 flex justify-end">
        <button
          onClick={onDismiss}
          disabled={dismissing}
          className="rounded-md font-semibold inline-flex items-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-default-600 bg-white hover:bg-slate-50 text-default-800 border border-gray-200 shadow-sm text-gray-500 px-2.5 py-1.5 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span className="truncate">J'ai compris</span>
        </button>
      </div>
    </div>
  );
};
